module.exports = __webpack_public_path__ + "img/US@2x.b8d07684.png";